import baseConfig from './config.js';
import $app from './app.js';
import loading from './loading';
import qs from 'qs';
import axios from 'axios';
import {message as $message} from 'ant-design-vue';

const PAGE_SIZE = 10;
const request = function (parameters) {
    let me = this;

    let context = parameters.context; //上下文，一般指vue对象
    let data = parameters.data || {}; //注：切记当method为get时data必须为简单的键值对
    let requestUrl = parameters.url; //URL对象
    let urlParams = parameters.urlParams || {};
    let isQsStringify = parameters.isQsStringify === undefined ? true : parameters.isQsStringify; //对象 序列化成URL以&进行拼接[默认true]
    let isShowLoading = parameters.isShowLoading == undefined ? true : parameters.isShowLoading; //是否显示loading,用于静默AJAX[默认true]
    let needLogin = parameters.needLogin == undefined ? true : parameters.needLogin; //接口是否需要登录,[默认true]

    let waitingtip = parameters.waitingtip || '处理中,请稍候……';

    requestUrl = this.appendUrlParameter(requestUrl, urlParams);

    let defaultAjaxOpt = {
        //ajax的参数配置
        dataType: 'json', //传输数据的数据类型
        type: 'POST', //HTTP请求类型
        timeout: 100000 //超时时间设置为100秒
    };
    let ajaxOpt = {...defaultAjaxOpt, ...parameters.ajaxOpt};

    let defaultHeaders = {
        //设置请求的默认 header
        //"content-type":"application/json"
    };
    if (ajaxOpt.type == 'POST' || ajaxOpt.type == 'PUT') {
        //如果是POST需要设置参数
        //defaultHeaders["content-type"] = "application/x-www-form-urlencoded";
    }
    let headers = {...defaultHeaders, ...parameters.headers};

    if (needLogin) {
        let user = $app.getState();
        if (user && user.token) {
            headers.Authorization = 'Bearer ' + user.token;
        }
    }

    if (isShowLoading) {
        loading.showLoading(context, waitingtip);
    }

    if (baseConfig.isDebug) {
        console.log('【rootPostAjax】请求地址：' + requestUrl);
        console.log('【rootPostAjax】请求参数：', data);
        console.log('【rootPostAjax】headers配置：', headers);
        console.log('【rootPostAjax】ajaxOpt配置：', ajaxOpt);
    }
    let postData = data;
    if (headers['content-type'] == 'application/x-www-form-urlencoded') {
        postData = qs.stringify(data, {indices: false});
    }

    let requestOpt = {
        url: requestUrl,
        method: ajaxOpt.type,
        timeout: ajaxOpt.timeout,
        dataType: ajaxOpt.dataType,
        headers,
        withCredentials: true, //表示跨域请求时是否需要使用凭证
        data: postData
    };
    if (ajaxOpt.responseType) {
        requestOpt.responseType = ajaxOpt.responseType;
    }
    if (ajaxOpt.type.toUpperCase() == 'GET') {
        delete requestOpt.data;
        requestOpt.params = postData;
    }

    axios(requestOpt)
        .then(function (res) {
            if (isShowLoading) {
                loading.hideLoading(context);
            }
            if (res.status !== 200) {
                //状态不为成功
                if (baseConfig.isDebug) {
                    console.log('接口调用失败了,状态码：' + res.status);
                }
                _defaultError({}, '接口调用失败了,状态码：' + res.status, parameters);
                return;
            }
            //返回值尽包含code,msg[可选],data，code返回0或者2XX表示成功，否则失败
            //注：失败时msg才有值
            let data = res.data; //data下才是我们自己的协议格式，包括code,data,message
            let message = data.msg;
            let resultCode = res.data.code;

            if (resultCode === 0 || (resultCode + '').startsWith('2')) {
                //表示成功
                _defaultSuccess(data, parameters);
            } else if ((resultCode + '').startsWith('5')) {
                _defaultError({}, '服务器异常！', parameters);
                return;
            } else {
                if (baseConfig.isDebug) {
                    console.log('接口调用成功，业务错误');
                }
                _defaultError(data, message, parameters);
            }
        })
        .catch(function (error) {
            if (isShowLoading) {
                loading.hideLoading(context);
            }

            if (!error.response) {
                _defaultError({}, '请求失败', parameters);
                return;
            } else if ((error.response.status + '').startsWith('5')) {
                _defaultError({}, '服务器异常！', parameters);
                return;
            } else if (error.response.status === 401) {
                context.$confirm({
                    title: '登录超时',
                    content: '登录超时，请重新登录!',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '',
                    onOk() {
                        $app.localLogout(context, true);
                        let loginUrl = '/login';
                        window.document.location.href = loginUrl;
                    },
                    onCancel() {
                        $app.localLogout(context, true);
                        let loginUrl = '/login';
                        window.document.location.href = loginUrl;
                    }
                });
                return;
            }
            //暗物是error,我们是MSGs
            let errorMsg = error?.response?.data?.error || error?.response?.data?.msg;
            _defaultError(error, errorMsg, parameters);
        });
};

const appendUrlParameter = function (url, urlParamObj, isAppendUndefined) {
    if (!urlParamObj || !url) {
        return url;
    }

    let symbol = '?';
    for (let key in urlParamObj) {
        if (url.indexOf('?') >= 0) {
            symbol = '&';
        }
        let _value = urlParamObj[key] == undefined ? '' : urlParamObj[key];
        url += symbol + key + '=' + _value;
    }
    if (baseConfig.isDebug) {
        console.log('appendUrlParameter---:' + url);
    }
    return url;
};

const _defaultSuccess = function (data, parameters) {
    if (parameters.success != null && typeof parameters.success == 'function') {
        if (baseConfig.isDebug) {
            console.log('接口调用成功，返回正确结果,开始回调自定义success');
        }
        try {
            parameters.success(data, parameters);
            if (baseConfig.isDebug) {
                console.log('basicRequest###接口调用成功，回调自定义success完成');
            }
        } catch (err) {
            console.error('basicRequest###执行success回调异常:' + err);
            console.error('basicRequest###执行success异常,请求目录地址>>>>>>>>:' + JSON.stringify(parameters.url));
            console.error('basicRequest###执行success异常,请求参数>>>>>>>>:' + JSON.stringify(parameters.data));
        }
        return;
    }
    if (baseConfig.isDebug) {
        console.log('接口调用成功，返回正确结果,执行默认defaultSuccess');
    }
};

const handleFinallyCallback = (error, message, parameters) => {
    if (parameters.finally != null && typeof parameters.finally == 'function') {
        try {
            parameters.finally(error, message, parameters);
        } catch (err) {
            console.error('basicRequest###回调自定义finally异常:' + err);
        }
    }
};

const _defaultError = function (error, message, parameters) {
    // console.error('basicRequest###执行异常,错误原因:' + message);
    // console.error('basicRequest###执行异常,请求目录地址>>>>>>>>:' + JSON.stringify(parameters.url));
    // console.error('basicRequest###执行异常,请求参数>>>>>>>>:' + JSON.stringify(parameters.data));
    if (!navigator.onLine) {
        handleFinallyCallback(error, message, parameters);
        $message.open({
            type: 'error',
            content: '网络异常！',
            key: 'globalNetworkMsg'
        });
        return;
    }
    if (parameters.error != null && typeof parameters.error == 'function') {
        // console.error('basicRequest###开始回调自定义error');
        try {
            parameters.error(error, message, parameters);
            // console.error('basicRequest###回调自定义error完成');
        } catch (err) {
            console.error('basicRequest###回调自定义error异常:' + err);
        }
        return;
    }
    $message.error(message);
};

export default {
    request,
    appendUrlParameter
};
